import { FeatureFlagReadModel } from "featureFlags"
import { bootDeferredAnalytics } from "cookiesConsent/features/bootDeferredAnalytics"
import { bootVisitorIdentityAnalytics } from "cookiesConsent/features/bootVisitorIdentityAnalytics"

export const bootAnalytics = (flagReadModel: FeatureFlagReadModel): void => {
  if (flagReadModel.getByName(`ENABLE_IDENTITY_RESET_WEB_5097`).isEnabled()) {
    bootVisitorIdentityAnalytics()
  } else {
    bootDeferredAnalytics()
  }
}
